export const PAGE_INDEX = {
  ready: () => {
    // console.log('page ready');
  }
};